import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import WorkspaceOrganizationMemberAppResource from './WorkspaceOrganizationMemberAppResource';
import WorkspaceTypeAppResource from "./WorkspaceTypeAppResource";
import ProjectTypeRoleAppResource from "./ProjectTypeRoleAppResource";

export const ASSISTANT = 'assistant';
export const APPLICANT = 'applicant';
export const CO_APPLICANT = 'coApplicant';
export const ATTORNEY = 'attorney';
export const CREDIT_COUNSELOR = 'creditCounselor';
export const FINANCIAL_PLANNER = 'financialPlanner';
export const HOME_INSPECTOR = 'homeInspector';
export const HOME_BUYER = 'homebuyer';
export const HOME_OWNERS_INSURANCE_AGENT = 'homeownersInsuranceAgent';
export const MORTGAGE_LENDER = 'mortgageLender';
export const REAL_ESTATE_AGENT = 'realEstateAgent';
export const REVERSE_MORTGAGE_COUNSELOR = 'reverseMortgageCounselor';
export const TITLE_OR_ESCROW_AGENT = 'titleOrEscrowAgent';
export const TRANSACTION_COORDINATOR = 'transactionCoordinator';
export const OTHER = 'other';
export const APPRAISER = 'appraiser';
export const HOME_STAGER = 'homeStager';
export const HOME_OWNER = 'homeOwner';
export const PHOTOGRAPHER = 'photographer';
export const HOME_WARRANTY = 'homeWarranty';
export const LOAN_OFFICER_ASSISTANT = 'loanOfficerAssistant';
export const MOVER = 'mover';
export const PROCESSOR = 'processor';
export const REAL_ESTATE_BROKER = 'realEstateBroker';
export const UNDERWRITER = 'underwriter';
export const LOAN_OFFICER = 'loanOfficer';

export const CLEANER = 'cleaner';
export const ELECTRICIAN = 'electrician';
export const GENERAL_CONTRACTOR = 'generalContractor';
export const HANDYMAN = 'handyman';
export const HVAC_CONTRACTOR = 'hvacContractor';
export const INTERNAT_CATV_PROVIDER = 'internetCatvProvider';
export const LANDSCAPER = 'landscaper';
export const LOCKSCAPER = 'lockscaper';
export const MORTGAGE_SERVICER = 'mortgageServicer';
export const NATURAL_GAS_PROVIDER = 'naturalGasProvider';
export const PAINTER = 'painter';
export const PEST_CONTROL = 'pestControl';
export const PLUMER = 'plumer';
export const POOL_AND_SPA_MAINTENANCE = 'poolAndSpaMaintenance';
export const PREVOIUS_HOMEOWNER = 'previousHomeowner';
export const HOME_SERVICE_PROFESSIONAL = 'homeServiceProfessional';
export const PREVOIUS_OWNER = 'previousOwner';
export const PROPANE_PROVIDER = 'propaneProvider';
export const PROPERTY_MANAGER = 'propertyManager';
export const ROOFING_AND_GUTTER_CONTRACTOR = 'roofingAndGutterContractor';
export const SECURITY_AND_ALERT_TECHNICIAN = 'securityAndAlartTechnician';
export const SEPTIC_TANK_SERVICE_PROVIDER = 'septicTankServiceProvider';
export const TAX_CONSULTANT = 'taxConsultant';
export const HOME_CONCIERGE = 'homeConcierge';


export const TYPE = {
    APPLICANT,
    CO_APPLICANT,
    ASSISTANT,
    ATTORNEY,
    CREDIT_COUNSELOR,
    FINANCIAL_PLANNER,
    HOME_INSPECTOR,
    HOME_BUYER,
    HOME_OWNERS_INSURANCE_AGENT,
    MORTGAGE_LENDER,
    REAL_ESTATE_AGENT,
    REVERSE_MORTGAGE_COUNSELOR,
    TITLE_OR_ESCROW_AGENT,
    TRANSACTION_COORDINATOR,
    OTHER,
    APPRAISER,
    HOME_STAGER,
    HOME_OWNER,
    PHOTOGRAPHER,
    HOME_WARRANTY,
    LOAN_OFFICER_ASSISTANT,
    MOVER,
    PROCESSOR,
    REAL_ESTATE_BROKER,
    UNDERWRITER,
    LOAN_OFFICER,

    CLEANER,
    ELECTRICIAN,
    GENERAL_CONTRACTOR,
    HANDYMAN,
    HVAC_CONTRACTOR,
    INTERNAT_CATV_PROVIDER,
    LANDSCAPER,
    LOCKSCAPER,
    MORTGAGE_SERVICER,
    NATURAL_GAS_PROVIDER,
    PAINTER,
    PEST_CONTROL,
    PLUMER,
    POOL_AND_SPA_MAINTENANCE,
    PREVOIUS_HOMEOWNER,
    HOME_SERVICE_PROFESSIONAL,
    PREVOIUS_OWNER,
    PROPANE_PROVIDER,
    PROPERTY_MANAGER,
    ROOFING_AND_GUTTER_CONTRACTOR,
    SECURITY_AND_ALERT_TECHNICIAN,
    SEPTIC_TANK_SERVICE_PROVIDER,
    TAX_CONSULTANT,
    HOME_CONCIERGE
};

class LuWorkspaceMembershipTypeAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'Lu-Workspace-Membership-Type';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'lus/workspaces/memberships/types';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'name',
            'slug',
            'description',
            'workspaceOrganizationMembers',
            'projectTypes',
            'projectTypeLinks',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            workspaceOrganizationMembers: WorkspaceOrganizationMemberAppResource,
            projectTypes: WorkspaceTypeAppResource,
            projectTypeLinks: ProjectTypeRoleAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {};
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            name: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            slug: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
        };
    }

}

export default LuWorkspaceMembershipTypeAppResource;
